import { Box } from "@mui/material";

const LogoVnpost = ({ width = 300 }) => {
  return (
    <Box
      component="img"
      src={`${process.env.REACT_APP_PATH}/vnpost-logo.png`}
      alt="logo"
      width={width}
    />
  );
};

export default LogoVnpost;
